export const ROUTE_GUARD_ROLES = ['ORG OWNER', 'NURSE', 'BASIC'];
export const ROUTE_GUARD_USER_TYPES = ['DOCTOR'];